import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Regions from './components/Regions/Regions';
import Features from './components/Features/Features';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  useEffect(() => {
    // Динамическое определение текущего города для аналитики
    const city = window.location.hostname.split('.')[0];
    if (city && city !== 'regioncheck') {
      console.log(`Region: ${city}`);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Regions />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;